'use strict';

function DetectVideoAutoPlay() {
  this.id = null;
  this.node = null;
  this.extends = [];
  this._videoElements = null;
  this._pausedClass = 'video--paused';
  this._notPausedClass = 'video--not-paused';

  this.init = function () {
    $(this.node).show();
  };

  this.initAllReady = function () {
    this._detectAutoPlay();
  };

  this._detectAutoPlay = function () {
    var _this = this;
    this._videoElements = $(this.node).find('video');

    // waits a 100ms to check if the video is paused
    setTimeout(function () {
      // if video is paused adds class
      if (_this._videoElements.get(0).paused) {
        _this.autoPlayNotDetected();
      } else {
        _this.autoPlayDetected();
      }
    }, 100);
  };

  this.autoPlayDetected = function () {
    this._videoElements.parent('*').addClass(this._notPausedClass);
  };

  this.autoPlayNotDetected = function () {
    this._videoElements.parent('*').addClass(this._pausedClass);
  };
}